var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.plan.provider.termsCondLink != null)?_c('span',[_c('a',{staticClass:"b-link_primary-dark",attrs:{"target":"_blank","href":_vm.plan.provider.termsCondLink}},[_vm._v("See")])]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }